module.exports = __webpack_public_path__ + "img/rust-lang-icon.27f7f50e.svg";